module.exports = {
	"shared.crew.original-music-composer": "Özgün Müzik / Besteci",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Gazeteci",
	"share-overlay.share": "Bu videoyu paylaş",
	"shared.crew.associate-producer": "Yapımcı Ortağı",
	"shared.crew.assistant-editor": "Editör Yardımcısı",
	"overlay.buy-from": "Satın Al {price}",
	"shared.crew.agent": "Ajan",
	"shared.crew.additional-photography": "Ek Fotoğrafçı",
	"shared.crew.sound-editor": "Ses Editörü",
	"shared.crew.print-shipper": "Baskı Gönderici",
	"shared.crew.hairstylist": "Saç Stilisti",
	"shared.crew.makeup-effects": "Makyaj Efektleri",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Prodüksyon Asistanı",
	"shared.crew.executive-producer": "Üst Yapımcı",
	"shared.crew.costumer": "Kostümcü",
	"info-overlay.cast": "Oyuncular",
	"shared.crew.stunt-coordinator": "Stunt Koordinatörü",
	"shared.crew.academic-advisor": "Akademik Danışman",
	"shared.crew.swing-gang": "Swing Gang",
	"shared.crew.best-boy": "Taşıyıcı",
	"actions.purchased": "Bu video artık sizin",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Set Dekoratörü",
	"shared.crew.adaptation": "Uyarlama",
	"shared.crew.school-administrator": "Okul Yöneticisi",
	"shared.crew.cable-person": "Kablocu",
	"shared.crew.digital-effects": "Dijital Efektler",
	"actions.rent": "Kirala {price}",
	"info-overlay.created-by": "Yazar: {author}",
	"social-share.twitter": "İzle: \"{title}\" - {siteUrl}",
	"shared.crew.production-designer": "Yapım Tasarımcısı",
	"info-overlay.crew": "Ekip",
	"shared.crew.producer": "Yapımcı",
	"shared.crew.2nd-unit-dir-of-photography": "2. Ünite Fotoğraf Yönetmeni",
	"shared.crew.special-effects": "Özel Efektler",
	"actions.rented": "{tarih} tarihine kadar kiralandı",
	"shared.crew.boom-operator": "Boom Operatörü",
	"shared.crew.story": "Hikaye",
	"shared.crew.script-supervisor": "Senaryo Danışmanı",
	"shared.crew.director": "Yönetmen",
	"shared.crew.choreographer": "Kareograf",
	"shared.crew.production-manager": "Prodüksyon Müdürü",
	"quality.auto": "Otomatik",
	"shared.crew.lead-person": "Lider Kişi",
	"shared.crew.location-manager": "Yerel Yönetmen",
	"shared.crew.costume-designer": "Kostüm Tasarımcısı",
	"fullscreen.exit": "Tam ekrandan çık",
	"shared.crew.technical-advisor": "Teknik Danışman",
	"shared.crew.editor": "Editör",
	"shared.crew.additional-grip": "Yardımcı Set Yönetmeni",
	"actions.buy": "Satın Al {price}",
	"shared.crew.assistant-camera": "Kamera Asistanı",
	"shared.crew.writer": "Yazar",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Yardımcı Yönetmen",
	"fullscreen.enter": "Tam Ekran",
	"shared.crew.animal-trainer": "Hayvan Eğiticisi",
	"shared.crew.assistant-art-director": "Yardımcı Sanat Yönetmeni",
	"shared.crew.key-grip": "Set Yönetmeni",
	"social-button.copy": "Kopyala",
	"shared.crew.makeup-artist": "Makyaj Sanatçısı",
	"overlay.source-error": "Video oynatılamıyor",
	"social-button.link": "Bağlantı",
	"actions.buy-from": "Satın Al {price}",
	"shared.crew.art-director": "Sanat Yönetmeni",
	"shared.crew.production-coordinator": "Prodüksyon Koordinatörü",
	"shared.crew.co-director": "Eş-Yönetmen",
	"shared.crew.co-producer": "Eş-Yapımcı",
	"shared.crew.video-operator": "Video Operatörü",
	"shared.crew.camera-operator": "Kamera Operatörü",
	"shared.crew.co-writer": "Eş-Yazar",
	"shared.crew.set-designer": "Set Tasarımcısı",
	"shared.crew.preview-return": "Önizleme",
	"shared.crew.property-master": "Mülkiyet Sorumlusu",
	"shared.crew.cinematographer-dp": "Görüntü Yönetmeni / DP",
	"shared.crew.grip": "Kavrama",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Ses Düzenlemecisi",
	"quality.label": "Kalite",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Işıkçı",
	"shared.crew.assistant-director": "Asistan Yönetmen",
	"actions.subscribe": "Abonelik {price}/Ay",
	"shared.crew.print-return": "Baskı Dönüşü",
	"shared.crew.animator": "Animatör",
	"shared.crew.dolly-grip": "Dolly Kavrama",
	"shared.crew.manager": "Yönetici",
	"shared.crew.2nd-assistant-director": "2. Asistan Yönetmen",
	"shared.crew.author-of-adapted-material": "Uyarlama Metin Yazarı"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_tr.json
// module id = 2800
// module chunks = 66